<template>
  <div class="mydialog">
    <div class="page_title">药师信息列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>药师姓名</span>
                <el-input
                  v-model="real_name"
                  style="width: 160px; margin: 0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>账号</span>
                <el-input
                  v-model="user_phone"
                  style="width: 160px; margin: 0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>提交时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin: 0 12px"
                  @change="
                    (value) => {
                      return search(value, 1);
                    }
                  "
                ></el-date-picker>

                <el-button
                  type="info"
                  style="background-color: #eceff2; color: #747981"
                  @click="search"
                >查询</el-button>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="药师姓名"
                  prop="real_name"
                ></el-table-column>

                <el-table-column label="性别">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-else>女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="账号"
                  prop="user_phone"
                ></el-table-column>

                <el-table-column
                  label="职称"
                  prop="title"
                ></el-table-column>
                <el-table-column
                  label="执业资格证号"
                  prop="certificate_no"
                ></el-table-column>
                <el-table-column
                  label="提交日期"
                  prop="update_time"
                ></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status">正常</span>
                    <span
                      style="color: #f24b2f"
                      v-else
                    >锁定</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.admin_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('105')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status"
                      @click="updateStatus(scope.row.admin_id, 1)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('104')
                          : false
                      "
                    >锁定</el-button>
                    <el-button
                      type="text"
                      v-if="!scope.row.status"
                      @click="updateStatus(scope.row.admin_id, 2)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('104')
                          : false
                      "
                    >解锁</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hospital from '../../../api/hospital';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      org_type_list: [],
      real_name: '',
      user_phone: '',
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取配置信息
    getConfig() {
      platform.getConfigList().then((res) => {
        if (res.code == 0) {
          this.org_type_list = res.data.org_type_list;
        }
      });
    },
    //获取审核列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        real_name: this.real_name
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      hospital
        .getPharmacistList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToDate(item.update_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search(value, status) {
      if (status) {
        if (!value) {
          this.date = [];
        }
      }
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //药师详情
    toDetail(admin_id) {
      this.$router.push({ path: 'yaoshilistdetail', query: { admin_id } });
    },
    //锁定/解锁
    updateStatus(admin_id, pharmacist_status) {
      if (pharmacist_status == 1) {
        this.$confirm('锁定后药师认证不可用，确定操作？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            hospital
              .changePharmacistStatus({ admin_id, pharmacist_status })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('药师状态已经更改!');
                }
                this.getList();
              });
          })
          .catch();
      } else {
        this.$confirm('确定更改药师认证状态？', '提示', {
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            hospital
              .changePharmacistStatus({ admin_id, pharmacist_status })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('药师状态已经更改!');
                }
                this.getList();
              });
          })
          .catch();
      }
    }
  },
  created() {
    this.getConfig();
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>